import styles from "./styles.module.scss"
import ArrowForwardOutline from "~icons/eva/arrow-forward-outline"
import classNames from "classnames"

const BookedCruiseCardSkeleton = () => {
  return (
    <div className={styles.bookedCruiseCardSkeleton}>
      <div className={classNames(styles.image, styles.shimmer, styles.startShimmer)}></div>
      <div className={classNames(styles.content)}>
        <div className={styles.blurView}>
          <div className={classNames(styles.row, styles.spaceBetween)}>
            <div className={classNames(styles.column, styles.flex)}>
              <div
                className={classNames(styles.cruiseName, styles.shimmer, styles.startShimmer)}
              ></div>
              <div
                className={classNames(styles.cruiseLine, styles.shimmer, styles.startShimmer)}
              ></div>
            </div>
            <div
              className={classNames(styles.cruiseLineImage, styles.shimmer, styles.startShimmer)}
            ></div>
          </div>
          <div className={styles.spacer}></div>
          <div className={classNames(styles.row, styles.spaceBetween, styles.alignCenter)}>
            <div className={styles.column}>
              <div
                className={classNames(styles.datePrefix, styles.shimmer, styles.startShimmer)}
              ></div>
              <div
                className={classNames(styles.dateSkeleton, styles.shimmer, styles.startShimmer)}
              ></div>
              <div
                className={classNames(styles.datePrefix, styles.shimmer, styles.startShimmer)}
              ></div>
            </div>
            <div className={styles.center}>
              <ArrowForwardOutline />
            </div>
            <div className={styles.column}>
              <div
                className={classNames(styles.datePrefix, styles.shimmer, styles.startShimmer)}
              ></div>
              <div
                className={classNames(styles.dateSkeleton, styles.shimmer, styles.startShimmer)}
              ></div>
              <div
                className={classNames(styles.datePrefix, styles.shimmer, styles.startShimmer)}
              ></div>
            </div>
          </div>
          <div className={styles.spacer}></div>
          <div className={styles.column}>
            <div
              className={classNames(styles.portsText, styles.shimmer, styles.startShimmer)}
            ></div>
            <div className={styles.column}>
              <div
                className={classNames(styles.cruisePorts, styles.shimmer, styles.startShimmer)}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BookedCruiseCardSkeleton
